import { graphql } from '../../gql';

export const WEEK_SELECTION_LIST_QUERY = graphql(`
  query WeekSelectionList {
    selectionList {
      week {
        id
        shortName
      }
    }
  }
`);
